import { all, Specification } from '@/core/specification';
import { Contact } from './contact.model';

export interface FamilyMember {
  first: string;
  last: string;
  birth: string;
}

export interface Member {
  first: string;
  last: string;
  birth: string;
  key: string;
  uuid: string;
  index: number;
  street: string;
  number: string;
  code: string;
  neighbourhood?: boolean;
  place: string;
  contacts: Contact[];
  pending: boolean;
}

const matchSearch = (search: string): Specification<Member> => {
  return (input: Member): boolean =>
    search
      ? input.first.toLowerCase().indexOf(search) !== -1 ||
        input.last.toLowerCase().indexOf(search) !== -1 ||
        input.street.toLowerCase().indexOf(search) !== -1 ||
        (input.contacts || []).some(
          (c) => c.email.toLowerCase().indexOf(search) !== -1,
        )
      : true;
};
const matchYear = (years: number[]): Specification<Member> => {
  return (input: Member): boolean =>
    years && years.length
      ? years.includes(new Date(input.birth).getFullYear())
      : true;
};
const matchPending = (status: number[]): Specification<Member> => {
  return (input: Member): boolean =>
    status && status.length ? input.pending === true : true;
};

export interface MemberFilterSettings {
  [index: string]: (string | number)[];
}

export const createMemberSpecification = (
  filters: MemberFilterSettings,
): Specification<Member> => {
  return all<Member>(
    matchSearch((filters.search && (filters.search[0] as string)) || ''),
    matchYear(filters.year as number[]),
    matchPending(filters.status as number[]),
  );
};
